import React from 'react'
import { Breadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import './Breadcrumbs.scss'
import { useTranslation } from 'react-i18next'

const Breadcrumbs = ({
  getBreadcrumbFolders,
  navigateToFolder,
  currentPath,
  query
}) => {
  // Debug: Log the breadcrumb folders
  const breadcrumbFolders = getBreadcrumbFolders()

  const { t } = useTranslation()

  return (
    <Breadcrumb>
      <Breadcrumb.Item>
        <a
          onClick={() => navigateToFolder('/')}
          style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
        >
          <HomeOutlined />
          {t('v4:home')}
        </a>
      </Breadcrumb.Item>
      {breadcrumbFolders.map((folder, idx) => (
        <Breadcrumb.Item key={folder.id}>
          <a onClick={() => navigateToFolder(folder)}>
            {folder.name ||
              folder.title ||
              folder.folder_path ||
              `Folder ${folder.id}`}
          </a>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  )
}

export default Breadcrumbs
